import { render } from "./layoup-pa.vue?vue&type=template&id=51b6324f"
import script from "./layoup-pa.vue?vue&type=script&lang=js"
export * from "./layoup-pa.vue?vue&type=script&lang=js"

import "./layoup-pa.vue?vue&type=style&index=0&id=51b6324f&lang=scss"

import exportComponent from "C:\\proyectos-alliances\\alliance.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__